import { SERVER_API_URL } from "../constants/constants";
import axios from "axios";

const getAuthConfig = () => {
  const token = localStorage.getItem("token");

  return {
    headers: { Authorization: `Bearer ${token}` },
  };
};

const generateReport = async (filters) => {
  const config = getAuthConfig();
  const { page, searchTerm = "", startDate = null, endDate = null } = filters;

  let url = `${SERVER_API_URL}/admin/admin_video_report/getVideoReport?page=${page}&search=${searchTerm}`;

  if (startDate) {
    url += `&startDate=${startDate}`;
  }

  if (endDate) {
    url += `&endDate=${endDate}`;
  }

  const result = await axios.get(url, config);
  return result.data;
};

const getAllReports = async (filters = {}) => {
  const config = {
    ...getAuthConfig(),
    params: {
      page: filters.page || 1,
      limit: filters.limit || 10,
    },
  };

  if (filters.reportType) {
    config.params.report_type = filters.reportType;
  }

  if (filters.searchTerm) {
    config.params.search = filters.searchTerm;
  }

  const result = await axios.get(
    `${SERVER_API_URL}/admin/admin_video_report/getAllReports`,
    config
  );

  return result.data;
};

export { generateReport, getAllReports };
